import React from 'react';
import {
  Filter as FilterAdmin,
  TextInput,
  BooleanInput,
  ReferenceInput,
  SelectInput,
  AutocompleteInput,
} from 'react-admin';

import { STATUS_ATIVO } from '../../utils';

const Filter = (props) => (
  <FilterAdmin {...props}>
    <TextInput label="Descrição" source="nome" />
    {/* <ReferenceInput
      source="setor_id"
      reference="setores"
      label="Setor"
      allowEmpty={false}
    >
      <SelectInput optionText="nome" allowEmpty={false} />
    </ReferenceInput> */}
    <ReferenceInput
      fullWidth
      label="Colaborador"
      source="colaborador_id"
      reference="colaboradores"
      sort={{ field: 'nome', order: 'ASC' }}
      filterToQuery={(searchText) => ({ nome: `${searchText}` })}
      filter={{ status: STATUS_ATIVO }}
      perPage={30}
    >
      <AutocompleteInput optionText="nome" />
    </ReferenceInput>
  </FilterAdmin>
);

export default Filter;
